import { Zap, Eye, Wallet, Scale } from "lucide-react";

const features = [
  {
    icon: Zap,
    title: "Policy issues surfaced fast",
    body: "Reputely scans incoming reviews, spots policy violations, and prepares the next action before your team has to hunt for it.",
  },
  {
    icon: Eye,
    title: "Every product stays watched",
    body: "Every monitored ASIN stays under review coverage, with alerts when new feedback creates a reputation risk.",
  },
  {
    icon: Wallet,
    title: "Subscription pricing",
    body: "Plans start at $79/month for continuous monitoring, policy detection, appeal generation, and alerts. Eligible Brand Registry brands can add managed filing.",
  },
  {
    icon: Scale,
    title: "We play by Amazon's rules",
    body: "We only flag reviews that already break Amazon's own rules. No fake reviews, no shady tricks.",
  },
];

export function FeatureGrid() {
  return (
    <section className="max-w-6xl mx-auto px-6 py-16">
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {features.map((f) => (
          <div
            key={f.title}
            className="rounded-2xl border border-slate-200 bg-white p-6 dark:border-slate-800 dark:bg-slate-900"
          >
            <f.icon className="h-6 w-6 text-emerald-600" />
            <h3 className="mt-4 font-medium text-slate-900 dark:text-slate-100">{f.title}</h3>
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
              {f.body}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
